import { FormEditor } from './../../models/editors/form-editor.base.model';

export class Dropdown extends FormEditor<string> {
  controlType = 'dropdown';
  options: { value: string, text: string }[] = [];
  iconTemplate: boolean;

  constructor(options: {} = {}) {
    super(options);
    this.options = options['options'] || [];
    this.iconTemplate = options['iconTemplate'] || false;
  }
}
